import _ from 'lodash';

let DATA_BROWSER_TABS = {
  users: {
    base: {
      options: {
        searchLabel: 'user\'s first name, last name or id',
        tabName: 'dataBrowser',
        uri: '/dataBrowser',
        dataSet: 'entitler',
        activeCellData: {}
      },
      columns: [{
        name: 'displayName',
        label: 'DATA_BROWSER_USER_NAME_ID_LABEL',
        type: 'table-grid-text-cell',
        isSortable: false,
        isClickable: true,
        virtualAttribute: (row) => {
          const display = `${row.familyName} , ${row.givenName} <br> ${row.role} <br> ${row.userId}`;
          return display;
        }
      }]
    },
    results: {
      options: {
        searchLabel: 'user\'s first name, last name or id',
        tabName: 'dataBrowser',
        uri: '/dataBrowser',
        dataSet: 'entitler',
      },
      columns: [{
        name: 'organizationName',
        label: 'DATA_BROWSER_USER_SCHOOL_LABEL',
        type: 'table-grid-text-cell',
        isSortable: false,
        virtualAttribute: (row) => {
          const display = row.organizationName ? row.organizationName : 'User-Level Assignment';
          return display;
        }
      }, {
        name: 'courseTitle',
        label: 'DATA_BROWSER_USER_COURSE_LABEL',
        type: 'table-grid-text-cell',
        isSortable: false,
        virtualAttribute: (row) => {
          const display = row.courseTitle ? `${row.courseTitle} <br> ${row.courseSourceSystemId}` : '';
          return display;
        }
      }, {
        name: 'sectionTitle',
        label: 'DATA_BROWSER_USER_CLASS_LABEL',
        type: 'table-grid-text-cell',
        isSortable: false,
        virtualAttribute: (row) => {
          let teacherName = getTeacherName(row);
          const display = row.sectionTitle ? `${row.sectionTitle} <br> ${row.sectionSourceSystemId} <br> ${teacherName}` : '';
          return display;
        }
      }, {
        name: 'personProductTitle',
        label: 'DATA_BROWSER_USER_PRODUCT_LABEL',
        type: 'table-grid-text-cell',
        isSortable: false,

        virtualAttribute: (row) => {
          let display = `${getProductTitle(row)}`;
          if (showToolTip(row)) {
            display += '<span class="icon data-browser_tooltip__icon info_icon"></span>';
          }
          return display;
        },

        tooltip: (row) => {
          if (showToolTip(row)) {
            if (row.courseProductAssignmentId) {
              return `Product is assigned to Course : ${row.courseTitle}`;
            }
            if (row.sectionProductAssignmentId) {
              return `Product is assigned to Class : ${row.sectionTitle}`;
            }
            if (row.personProductAssignmentId) {
              return 'Product is assigned to User';
            }
          }
        }
      }]
    }
  }
};

function showToolTip(row) {
  return row.courseProductAssignmentId || row.sectionProductAssignmentId || row.personProductAssignmentId;
}

function getTeacherName(row) {
  const ROLE_TEACHER = 'TEACHER';
  let teacherName = '';
  teacherName = row.role && (row.role.toUpperCase() === ROLE_TEACHER) ?  teacherName : `${_.trim(row.teacherName)}`;
  return teacherName;
}

function getProductTitle(row) {
  let text = 'No Product Affiliation';
  text = row.personProductTitle ? row.personProductTitle : text;
  text = row.courseProductTitle ? row.courseProductTitle : text;
  text = row.sectionProductTitle ? row.sectionProductTitle : text;

  text = row.personResourceTitle ? `${text}<br> ${row.personResourceTitle}` : text;
  text = row.courseResourceTitle ? `${text}<br> ${row.courseResourceTitle}` : text;
  text = row.sectionResourceTitle ? `${text}<br> ${row.sectionResourceTitle}` : text;

  return text;
}

export
default DATA_BROWSER_TABS;



// WEBPACK FOOTER //
// ./app/models/dataBrowserTabs.js